import { NgModule } from "@angular/core";
import { ServerTimeService } from "../services/server-time.service";
import { TimeDifPipe } from "./time-dif.pipe";

@NgModule({
  declarations: [
    TimeDifPipe
  ],
  providers: [
    ServerTimeService,
  ],
  exports: [
    TimeDifPipe
  ],
})
export class PipesModule {}
